export default "__VITE_ASSET__371RajgL__"